import { Renderer } from '@unseenco/taxi';
import { viewStorage } from '../_globals'
import Form from '../modules/form'

export default class PageCallback extends Renderer {
  initialLoad() {
    this.onEnter()
  }

  onEnter() {
    this.DOM = {
      callbackForm: viewStorage.current.querySelector('.Form')
    }
    this.init()
  }

  init() {
    const { callbackForm = null } = this.DOM
    if (callbackForm) this.formModule = new Form(callbackForm, 'submitWebCallBackSucceed')
  }

  onLeaveCompleted() {
    this.formModule && this.formModule.destroy()
  }
}
